// 注册「无可视控件」的表单字段用：rc-field-form 的 useWatch 只对已注册字段生效，
// 由 setFieldValue 写入的辅助字段（npiType / taxonomyOptions / billingEhrs 等）需要挂一个
// 空渲染控件到 Form.Item 下完成注册，值本身仍由外部 setFieldValue 驱动
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export default function HiddenFormField(props: { value?: any; onChange?: (v: any) => void }) {
    return null;
}
